export default "__VITE_ASSET__DxDNY7h0__"